export enum NotificationType {
    CreateTradeListing,
    ModifyTradeListing,
    CreatureIsSold,
    CreatureIsBought,
    TradeListingError,
    BreedingIsReady
}